import React from 'react'
import { Stack } from '@/components/admin/atoms/layout/Stack'
import { Label } from '@/components/admin/atoms/typography/Label'
import { Text } from '@/components/admin/atoms/typography/Text'

interface FormFieldProps {
  label: string
  htmlFor?: string
  hint?: string
  error?: string
  required?: boolean
  children: React.ReactNode
  className?: never
}

export const FormField: React.FC<FormFieldProps> = ({
  label, htmlFor, hint, error, required, children,
}) => (
  <Stack gap="1">
    <Label htmlFor={htmlFor} required={required}>{label}</Label>
    {hint && <Text size="xs" color="muted">{hint}</Text>}
    {children}
    {error && <Text size="xs" color="error">{error}</Text>}
  </Stack>
)
